import React from 'react';
import { TitleDivider } from '../title-divider';

export class PartnerGroup extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <>
        <TitleDivider>{ this.props.name }</TitleDivider>
        <div className="partner-grid">
          { this.props.partners && this.props.partners.map(partner => <Partner partner={partner} />) }
        </div>
      </>
    );
  }
}

class Partner extends React.Component {
  render () {
    return (
      <a className="partner" href={this.props.partner.url} target="_blank">
        { this.props.partner.logo && <img src={this.props.partner.logo.file.url} alt={this.props.partner.name} /> }
      </a>
    );
  }
}